import React from 'react';
import cx from 'classnames';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import styles from './PageLoader.scss';

type PageLoaderProps = {
  className?: string;
  hideLabel?: boolean;
  message?: string;
  showFooter?: 'full' | 'none';
}

const PageLoader = ({ className = '', hideLabel = false, message = '', showFooter }: PageLoaderProps) => (
  <div className={cx(styles.container, className, {
    [styles.contentHeight]: showFooter === 'full',
  })} data-testid="PageLoader">
    <LoadingArrow showText={!hideLabel && !!message} size="large" text={message} />
  </div>
);

export default PageLoader;
